import React from 'react';
import { Image, Spinner } from "react-bootstrap";
import { API_LIMIT } from './Constant';
import { toast } from 'react-toastify';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

const PDF_RENDER_SCALE = 4;

const readFileAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const getImageDimensions = (dataUrl) =>
  new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = dataUrl;
  });

const isPdfFile = (file) =>
  file?.type === 'application/pdf' ||
  file?.name?.toLowerCase().endsWith('.pdf');

const normalizeFiles = (files) =>
  (Array.isArray(files) ? files : [files])
    .map((file) => file?.file || file)
    .filter(Boolean);

const renderPdfPageToDataUrl = async (pdf, pageNumber, scale = PDF_RENDER_SCALE) => {
  const page = await pdf.getPage(pageNumber);
  const viewport = page.getViewport({ scale });
  const canvas = document.createElement('canvas');
  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);
  const context = canvas.getContext('2d');

  await page.render({ canvasContext: context, viewport }).promise;

  return canvas.toDataURL('image/png', 1);
};

const getPdfFileDetails = async (source) => {
  const file = source?.file || source;
  let objectUrl;

  try {
    const documentSource =
      typeof file === 'string'
        ? file
        : (objectUrl = URL.createObjectURL(file));

    const pdf = await pdfjsLib.getDocument({ url: documentSource }).promise;
    const firstViewport = (await pdf.getPage(1)).getViewport({ scale: PDF_RENDER_SCALE });
    const width = Math.floor(firstViewport.width);
    const height = Math.floor(firstViewport.height);
    const images = [];

    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      images.push(await renderPdfPageToDataUrl(pdf, pageNumber));
    }

    return { width, height, images };
  } finally {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    }
  }
};


// GET EXTENSION NAME WRAPPER
export const getExtensionNameWrapper = (attachmentName, attachmentUrl, className) => {
  const re = /(?:\.history([^.]+))?$/;
  let ext = re.exec(attachmentName)[1];
  let attachmentWrapper;

  if (ext === "jpeg" || ext === "png" || ext === "jpg") {
    attachmentWrapper = (
      <Image
        src={attachmentUrl}
        alt="link-preview"
      />
    )
  } else {
    attachmentWrapper = (
      <span className={className}>{ext}</span>
    )
  }
  return attachmentWrapper
}

export const calculateTotalPageCount = (totalCount) => {
  return Math.ceil(totalCount / API_LIMIT)
}

// export const getDropdownOption = (data) =>{
//   let options = data.map((item)=>{
//       "label": item.name,
//       "value": item.uuid
//     })
//     return options
// }

// export const getDropdownOption = (data) =>{
//   Object.keys(data).map(
//     (type) => ({
//       label: PricingType.presentable[type],
//       value: type
//     })
//   )
// }



const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp']; // Define your image extensions

export const isImage = (filePath) => {
  if (typeof filePath !== 'string') {
    return filePath?.type?.startsWith("image/");
  }

  const extension = filePath.toLowerCase().slice(filePath.lastIndexOf('.'));
  return imageExtensions.includes(extension);
};
export const isPDF = (filePath) => {
  if (typeof filePath !== 'string') {
    return false;
  }

  const extension = filePath.toLowerCase().slice(filePath.lastIndexOf('.'));
  return ['.pdf'].includes(extension);
};



export const replaceHistory = (history, page = 1, searchValue = "") => {
  history({
    search: `?p=${page}${searchValue && `&search=${searchValue}`}`
  }, { replace: true })
}
export const createEditorStateFromText = (text) => {
  if (!text) {
    return EditorState.createEmpty();
  }

  // Try to parse as HTML using html-to-draft
  const contentBlock = htmlToDraft(text);
  if (contentBlock?.contentBlocks?.length) {
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
      contentBlock.entityMap
    );
    return EditorState.createWithContent(contentState);
  }

  // Fallback to plain text
  return EditorState.createWithContent(ContentState.createFromText(text));
};

export const onlyUnique = (value, index, array) => {
  return array.indexOf(value) === index;
}

export const userRoleType = () => {
  return JSON.parse(localStorage.getItem("finAdmin"))?.user?.role?.roleType || '';

}
export const userAmcUuids = () => {
  return JSON.parse(localStorage.getItem("finAdmin"))?.amcUuids || '';

}
export const isFinpediaUser = () => {
  return JSON.parse(localStorage.getItem("finAdmin"))?.user?.contentCreator?.isFinpediaUser || false;

}
export const userCreatorUuids = () => {
  return JSON.parse(localStorage.getItem("finAdmin"))?.contentCreatorUuid || '';

}

export function safeParseJson(input, fallback = {}) {
  if (input == null) return fallback;          // null or undefined
  if (typeof input === "object") return input; // already parsed
  if (typeof input !== "string") return fallback;

  try {
    return JSON.parse(input);
  } catch (err) {
    // optional: console.warn("Invalid JSON for position:", err);
    return fallback;
  }
}
export function isBtnShow(url) {
  if (!url) {
    return true;
  }
  const urlExclude = ['.jpg', '.mp3', '.ogg', '.png', '.jpg', 'jpeg'];
  const lastDotIndex = url?.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return true;
  }

  const extension = url.slice(lastDotIndex).toLowerCase();
  return !urlExclude.includes(extension);
}


export const camelCaseTitle = (name) => {
  if (!name) return '';
  if (name.length === 1) return name.toLowerCase();
  if (typeof name !== 'string') return '';
  let camelCaseTitle = name.replace(/\s+(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });
  camelCaseTitle = camelCaseTitle.charAt(0).toLowerCase() + camelCaseTitle.slice(1);
  camelCaseTitle = camelCaseTitle.replace(/\s/g, '');
  return camelCaseTitle;
};

export const getFileDetailsFromFiles = async (files) => {
  const normalizedFiles = normalizeFiles(files);

  if (!normalizedFiles.length) {
    throw new Error('No files provided');
  }

  if (isPdfFile(normalizedFiles[0])) {
    return getPdfFileDetails(normalizedFiles[0]);
  }

  const images = await Promise.all(normalizedFiles.map(readFileAsDataUrl));
  const { width, height } = await getImageDimensions(images[0]);

  return { width, height, images };
};

export const getPDFImages = async (pdfSource) => {
  if (!pdfSource) {
    toast.error('Please select a PDF file.');
    return [];
  }

  try {
    const file = pdfSource?.file || pdfSource;
    const { images } = await getPdfFileDetails(file);
    const pageFiles = [];

    for (let i = 0; i < images.length; i++) {
      const response = await fetch(images[i]);
      const blob = await response.blob();
      pageFiles.push(
        new File([blob], `page-${i + 1}.png`, {
          type: 'image/png',
          lastModified: Date.now(),
        })
      );
    }

    return pageFiles;
  } catch (error) {
    console.error('Error generating PDF images:', error);
    throw error;
  }
};


export const filterVerifiedItems = (list = []) =>
  (Array.isArray(list) ? list : []).filter(
    (item) => item != null && (!('isVerified' in item) || item.isVerified)
  );

export const getLabelByValue = (value, data) => {
  if (data && data.length > 0) {
    const foundItem = data.find(item => item.value === value);
    return foundItem ? foundItem.label : null;
  }
  return null;
}

export const getAdminUser = () => localStorage.getItem("finAdmin") ? JSON.parse(localStorage.getItem("finAdmin"))?.user : null;

export const getSafeArray = (data) => {
  if (Array.isArray(data)) {
    return data;
  }
  if (typeof data === 'string' && data.trim() !== '') {
    return data.split(',').map(item => item.trim());
  }
  return [];
}
export const isPartnerAllowed = (moduleId) => {
  if (!moduleId) return true;
  return ![1, 2, 4, 31, 9, 13, 10, 53, 28, 23, 42, 21, 20, 52, 55].includes(moduleId)
}
export const showLoader = (isLoading, list) => {
  return (
    isLoading ?
      <div className="inter-medium f-s-18 lh-22 text-center py-5 d-flex align-items-center justify-content-center gap-8"> <Spinner animation="grow" /> Loading...</div>
      : (list?.length === 0) ?
        <div className="inter-medium f-s-18 lh-22 text-center py-5"> Result is not found.</div> : ''
  )
}
export async function s3UrlToFile(url, fileName) {
  try {
    const response = await fetch(url, { mode: "cors" });

    if (!response.ok) {
      console.error(`Failed to fetch ${url}:`, response.statusText);
      return null;
    }

    if (!fileName) {
      const ext = url.split(".").pop().split("?")[0]; // try to get extension from URL
      fileName = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}${ext ? "." + ext : ""}`;
    }


    const blob = await response.blob();
    const mimeType = blob.type || "application/octet-stream";

    const file = new File([blob], fileName, { type: mimeType });

    file.mimetype = mimeType;

    return file;
  } catch (err) {
    console.error("Error converting S3 URL to File:", err);
    return null;
  }
}
export const renameFile = (file, newName) => {
  const newFile = new File([file], newName, {
    type: file.type,
    lastModified: file.lastModified,
  });
  newFile.mimetype = file.type || "application/octet-stream";

  return newFile;

}

export const createRemoteContentRef = (url, meta = {}) => ({
  url,
  isNew: false,
  ...meta,
});

export const createLocalContentRef = (file) => ({
  file,
  isNew: true,
  name: file?.name,
});

export const normalizeContentFileFromApi = (value, isCarousel = false) => {
  if (!value) {
    return isCarousel ? [] : null;
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (!item) return null;
        if (item.isNew !== undefined) return item;
        if (typeof item === "string") return createRemoteContentRef(item);
        if (item.url) return { ...item, isNew: false };
        if (item.filePath) return createRemoteContentRef(item.filePath, item);
        if (item.file instanceof Blob && item.isNew) return item;
        if (item.file instanceof Blob) return createLocalContentRef(item.file);
        return item;
      })
      .filter(Boolean);
  }

  if (typeof value === "string") return createRemoteContentRef(value);
  if (value.isNew !== undefined) return value;
  if (value.url) return { ...value, isNew: false };
  if (value.file instanceof Blob && value.isNew) return value;
  if (value.file instanceof Blob) return createLocalContentRef(value.file);

  return value;
};

export const isContentFileLocal = (ref) =>
  ref?.isNew === true && ref?.file instanceof Blob;

export const resolveContentSource = (ref) => {
  if (!ref) return null;
  if (isContentFileLocal(ref)) return ref.file;
  if (ref.url) return ref.url;
  if (typeof ref === "string") return ref;
  if (ref.file instanceof Blob) return ref.file;
  if (typeof ref.file === "string") return ref.file;
  return null;
};

export const getContentPreviewUrl = (ref) => {
  const source = resolveContentSource(ref);
  if (!source) return null;
  if (source instanceof Blob) return URL.createObjectURL(source);
  return source;
};

export const getContentFileType = (ref) => {
  const source = resolveContentSource(ref);
  if (!source) return "";
  if (source instanceof Blob) return source.type || "";
  if (isPDF(source)) return "application/pdf";
  if (isImage(source)) return "image/";
  return "";
};

export const isContentFileImage = (ref) => {
  const type = getContentFileType(ref);
  if (type.startsWith("image/")) return true;
  return isImage(resolveContentSource(ref));
};

export const isContentFilePdf = (ref) => {
  const type = getContentFileType(ref);
  if (type === "application/pdf") return true;
  const source = resolveContentSource(ref);
  return (
    isPDF(source) ||
    (source instanceof Blob && source.type === "application/pdf")
  );
};

export const buildSingleContentFilePayload = (ref) => {
  if (!ref) return {};
  if (isContentFileLocal(ref)) return { fileName: ref.file.name };
  if (ref.url) return { contentFilePath: ref.url };
  if (ref.file?.name) return { fileName: ref.file.name };
  return {};
};

export const buildCarouselContentFilePayload = (refs) => {
  if (!refs?.length) return {};

  const imageNumber = refs.map((ref, idx) => {
    if (isContentFileLocal(ref)) {
      return { fileName: ref.file.name, number: idx };
    }
    return { filePath: ref.url, number: idx };
  });

  const localRefs = refs.filter(isContentFileLocal);
  if (localRefs.length === refs.length) {
    return {
      fileName: localRefs.map((ref) => ref.file.name),
      imageNumber,
    };
  }

  return { imageNumber };
};

export const appendContentFilesToFormData = (formData, contentFile) => {
  if (!contentFile) return;

  const refs = Array.isArray(contentFile) ? contentFile : [contentFile];
  refs.forEach((ref) => {
    if (isContentFileLocal(ref)) {
      formData.append("file", ref.file);
    }
  });
};
